<script>
  import { createEventDispatcher } from 'svelte';
  import FeIcon from '../components/fe-icon.svelte';
  import { pages } from '../../config';
  import { goto, sgoto } from '../../util';

  export let sid;
  export let sites = [];
  export let mode = 'sites.overview';

  const dispatch = createEventDispatcher();

  $: data = sites?.map(({ _id, domain, description }) => ({
    _id,
    domain,
    description,
  }));

  $: dataExists = data?.length;
  $: returnTo = `?from=${mode}`;

  function triggerDeleteSite(sid) {
    return () => {
      if (!sid) {
        console.warn('sid required for form deletion');
      } else {
        dispatch('delete', { sid });
        goto(pages.sites.delete.url, sid, returnTo);
      }
    };
  }
  function activate(site) {
    console.log('activate', site);
    const target = site === sid ? window.location.pathname : `?site=${site}`;
    dispatch('siteSwitched', { sid: site });
    return () => {
      sid = site; // updates state if needed
      sgoto(target);
    };
  }
</script>

{#if dataExists}
  <table class="sites-table">
    <thead>
      <tr>
        <th>Domain</th>
        <th>Description</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      {#each Object.values(data) as row}
        <tr class={row._id === sid ? 'active' : ''}>
          <td on:keydown={null} on:click={activate(row?._id)}>
            {row.domain}
          </td>
          <td on:keydown={null} on:click={activate(row?._id)}>
            {row.description}
          </td>
          <td class="cta">
            <div class="ctrl">
              <FeIcon name="x-circle" on:click={triggerDeleteSite(row._id)} />
              <FeIcon
                name="edit"
                on:click={() => goto(pages.sites.edit.url, row._id, returnTo)}
              />
              <FeIcon
                name="eye"
                on:click={() =>
                  goto(pages.sites.overview.url, row._id, returnTo)}
              />
              <FeIcon
                name="code"
                on:click={() => goto(pages.components.url, row._id, returnTo)}
              />
            </div>
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
{:else}
  <slot name="empty" />
{/if}

<style>
  .active {
    background: var(--secondary);
  }
</style>
